import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import Icon from 'components/Icon'

const Expandable = ({ expandLabel, collapseLabel, children, ...props }) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div {...props}>
      <div className="text-primary cursor-pointer hover:opacity-75" onClick={() => setExpanded(!expanded)}>
        { expanded ? collapseLabel : expandLabel } <Icon icon={['far', expanded ? 'chevron-up' : 'chevron-down']} />
      </div>

      { expanded &&
        <div className="border-l-2 border-gray-400 p-4 mt-4 whitespace-pre-line text-sm">
          { children }
        </div>
      }
    </div>
  )
}

export default Expandable

